import { createFileRoute } from "@tanstack/react-router";
import { GuestsPage } from "@/features/guests/guests-page";

export const Route = createFileRoute("/app/w/$weddingId/guests")({ component: GuestsPage });
